import Separator from 'components/Separator';
import Link from 'next/link';
import SnoozeSwitchSection from '../SnoozeSwitchSection';
import { SnoozeSubscriptionRegular } from './SnoozeSubscriptionRegular';
import { WelcomePlayerSection } from './WelcomePlayerSection';

import { useUserStore } from 'hooks/stores/useUserStore';
import { User } from 'types/User';

import { observer } from 'mobx-react-lite';
import { EntriesSection } from './EntriesSection';

export const AccountMenu = observer(
  ({
    isOpen,
    currentUser,
    welcomeBackPlanName,
    handleNavigate,
    signOutOnClick,
  }: {
    isOpen: boolean;
    currentUser: User;
    welcomeBackPlanName: string | null;
    handleNavigate: () => void;
    signOutOnClick: () => void;
  }) => {
    const {
      subscriptionStatus,
      activeWeeklyDrawSubscriptionTickets,
      claimablePrizesCount,
    } = useUserStore();
    if (!currentUser) {
      return null;
    }
    return (
      <div style={{ display: 'flex' }}>
        <div className={`w-full  flex-col justify-center items-center`}>
          <Separator
            style={{
              width: '98%',
              margin: '0',
              height: '2px',
            }}
          />
          <WelcomePlayerSection currentUser={currentUser} />
          {['LITE', 'PREMIUM'].includes(subscriptionStatus) && (
            <SnoozeSwitchSection
              style={undefined}
              SwitchComponent={SnoozeSubscriptionRegular}
            />
          )}

          {['LITE', 'PREMIUM'].includes(subscriptionStatus) &&
            activeWeeklyDrawSubscriptionTickets?.length > 0 && (
              <EntriesSection
                tickets={[activeWeeklyDrawSubscriptionTickets[0]]}
              />
            )}

          <div className="pt-[1em] px-[1em] flexLeftAligned fullWidth">
            <Link href="/dashboard">
              <a
                onClick={() => {
                  handleNavigate();
                }}
                className="menuLink !px-0 !mt-0"
              >
                My Dashboard
              </a>
            </Link>

            <Link href="/leaderboard">
              <a
                onClick={() => {
                  handleNavigate();
                }}
                className="menuLink !px-0"
              >
                Leaderboard
              </a>
            </Link>
            <Link href="/token-town">
              <a
                onClick={() => {
                  handleNavigate();
                }}
                className="menuLink !px-0"
              >
                Token Town
              </a>
            </Link>
            <Link href="/my-account">
              <a
                onClick={() => {
                  handleNavigate();
                }}
                className="menuLink !px-0 !mb-0"
              >
                My Account
                {claimablePrizesCount > 0 && (
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: '0.9em',
                      backgroundColor: 'red',
                      color: 'white',
                      borderRadius: 5000,
                      padding: '3px 10px',
                      minWidth: 20,
                      letterSpacing: 0,
                      marginLeft: 10,
                      whiteSpace: 'nowrap',
                      textTransform: 'uppercase',
                    }}
                  >
                    unclaimed prize
                  </span>
                )}
              </a>
            </Link>
          </div>

          <div className="w-full px-[1em]">
            <Separator
              style={{
                height: '2px',
              }}
            />
          </div>

          <div className="px-[1em] flexLeftAligned fullWidth">
            <a className={`menuLink !px-0 !mt-0`} onClick={signOutOnClick}>
              Sign out
            </a>
          </div>
        </div>
      </div>
    );
  }
);
